<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" class="ml-3">
        <span>Adicionar Iniciativas</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            {{ title }}
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                  limpar();
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col>
              <ComboboxTerritoriosCategorias
                :value="payload"
                ref="eixos"
                @onChange="changeEixo"
                :object="true"
              ></ComboboxTerritoriosCategorias>
            </v-col>
            <v-col v-if="payload.territorioCategoria">
              <ComboboxTerritoriosIniciativasByEixo
                :filter="payload"
                :territorioCategoriaId="
                  payload.territorioCategoria.territorioCategoriaId
                "
                :multiple="true"
                :iniciativasSelecionadas="iniciativasSelecionadas"
              ></ComboboxTerritoriosIniciativasByEixo>
            </v-col>
            <v-col cols="2">
              <v-btn color="primary" @click="addIniciativa">Adicionar</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div v-if="!payload.territorioIniciativa.length">
                Nenhuma Iniciativa
              </div>
              <template v-else>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(
                      territorioIniciativa, i
                    ) in payload.territorioIniciativa"
                    :key="i"
                    style="margin-bottom: 5px"
                  >
                    <v-card outlined>
                      <v-expansion-panel-header>
                        <v-col>
                          {{ territorioIniciativa.nomeIniciativa }}
                        </v-col>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content eager>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <div>
                                <v-text-field
                                  v-model="territorioIniciativa.inicio"
                                  v-mascara="'##/##/####'"
                                  label="Data Início"
                                  placeholder="00/00/0000"
                                  outlined
                                  hide-details="auto"
                                  :rules="rulesData"
                                ></v-text-field>
                              </div>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="territorioIniciativa.fim"
                                v-mascara="'##/##/####'"
                                label="Data Fim"
                                placeholder="00/00/0000"
                                outlined
                                hide-details="auto"
                                :rules="rulesData"
                              ></v-text-field>
                            </v-col>

                            <v-col>
                              <div>
                                <ComboboxTerritoriosStatus
                                  :value="territorioIniciativa"
                                  outlined
                                ></ComboboxTerritoriosStatus>
                              </div>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col>
                              <div>
                                Iniciativa implementada em todos os
                                {{ isGov ? "projetos" : "municípios" }} do
                                Território?
                              </div>
                              <v-radio-group
                                v-model="territorioIniciativa.todos"
                                row
                                :rules="[requiredBoolean]"
                                @change="
                                  (e) => {
                                    if (e) territorioIniciativa.excecao = null;
                                  }
                                "
                              >
                                <v-radio
                                  label="Sim"
                                  :key="1"
                                  :value="true"
                                ></v-radio>
                                <v-radio
                                  label="Não"
                                  :key="2"
                                  :value="false"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="territorioIniciativa.excecao"
                                :label="`Se NÃO, informar os ${
                                  isGov ? 'projetos' : 'municípios'
                                } que são exceção`"
                                outlined
                                hide-details="auto"
                                :rules="
                                  territorioIniciativa.todos == false
                                    ? [required]
                                    : [true]
                                "
                                :disabled="territorioIniciativa.todos"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <ComboboxTerritoriosReponsaveis
                                :filter="territorioIniciativa"
                              ></ComboboxTerritoriosReponsaveis>
                            </v-col>

                            <v-col>
                              <v-currency-field
                                label="Valor estimado total"
                                :prefix="'R$'"
                                outlined
                                hide-details="auto"
                                v-model="territorioIniciativa.custo"
                              />
                            </v-col>
                            <v-col>
                              <div>
                                <v-text-field
                                  v-model="territorioIniciativa.atores"
                                  label="Atores"
                                  outlined
                                  hide-details="auto"
                                ></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                label="Justificativa/Observações de status"
                                v-model="territorioIniciativa.observacoes"
                                outlined
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            outlined
                            color="error"
                            class="mr-3"
                            @click="deleteInicitiva(territorioIniciativa, i)"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-card>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              dialog = false;
              limpar();
            }
          "
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxTerritoriosCategorias from "@/modules/gestao-territorios/components/categorias/ComboboxTerritoriosCategorias";
import ComboboxTerritoriosIniciativasByEixo from "@/modules/gestao-territorios/components/iniciativas/ComboboxTerritoriosIniciativasByEixo";
import { dataRegexValidatior } from "@/helpers/validator";
import ComboboxTerritoriosStatus from "@/modules/gestao-territorios/components/status/ComboboxTerritorioIniciativaStatus";
import ComboboxTerritoriosReponsaveis from "../responsaveis/ComboboxTerritoriosReponsaveis.vue";
import { required, requiredBoolean } from "@/helpers/validator";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  name: "ModalAdicionarIniciativa",
  components: {
    ComboboxTerritoriosCategorias,
    ComboboxTerritoriosIniciativasByEixo,
    ComboboxTerritoriosStatus,
    ComboboxTerritoriosReponsaveis,
  },
  props: {
    filter: {},
    title: "",

    iniciativasSelecionadas: [],
    possuiMunicipio: { type: Boolean, required: false, default: false },
  },

  data() {
    return {
      payload: {
        territorioCategoria: null,
        territorioIniciativa: [],
        territorioIniciativaId: [],
      },
      rulesData: [
        (v, item) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }

          return true;
        },
      ],
      requiredBoolean: requiredBoolean,
      required: required,
      dialog: false,
      valid: true,
      headers: [
        { text: "Nome", value: "nomeIniciativa" },
        { text: "Datas", value: "date" },
        { text: "Datas", value: "date" },
        { text: "Responsáveis", value: "responsaveis" },
        { text: "Custo", value: "custo" },
        { text: "Atores", value: "atores" },
        { text: "Status", value: "status" },

        { text: "Ação", value: "action", width: "10%" },
      ],
    };
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    addIniciativa() {
      if (this.payload.territorioIniciativaId.length == 0) return;
      this.payload.territorioIniciativa =
        this.payload.territorioIniciativaId.map((item) => ({
          ...this.payload.territorioCategoria,
          ...item,
          responsaveis: [],
        }));
    },
    limpar() {
      this.payload = { territorioIniciativa: [] };
      this.$forceUpdate();
    },
    changeEixo() {
      (this.payload.territorioIniciativa = []),
        (this.payload.territorioIniciativaId = []);
    },
    deleteInicitiva(item, index) {
      this.payload.territorioIniciativa.forEach((val, index) => {
        if (item == val) {
          this.payload.territorioIniciativa.splice(index, 1);
        }
      });
    },
    validateIniciativa() {
      let errors = [];
      this.payload.territorioIniciativa.forEach((item) => {
        if (
          moment(item.fim, "DD/MM/YYYY HH:mm").isBefore(
            moment(item.inicio, "DD/MM/YYYY HH:mm")
          )
        ) {
          errors.push(
            `<div style="margin-bottom:10px;"> ${item.nomeIniciativa} - Data final menor que data inicial</div>`
          );
        } else if (!item.todos) {
          errors.push(
            `<div style="margin-bottom:10px;"> ${
              item.nomeIniciativa
            } - O campo Iniciativa implementada em todos os ${
              this.isGov ? "Projetos" : "Municípios"
            }  é obrigatório</div>`
          );
        }
      });

      return errors.length > 0 ? errors.join("") : [];
    },
    async validate() {
      const valid = await this.$refs.form.validate();

      return valid;
    },
    async onConfirm() {
      if (!this.validate()) {
        return;
      }

      if (this.validateIniciativa().length) {
        Swal.fire({
          title: "Iniciativa inválida",
          html: this.validateIniciativa(),
          confirmButtonText: "Ok",
        });

        return;
      }

      if (
        !this.payload.territorioIniciativa ||
        this.payload.territorioIniciativa.length == 0
      ) {
        this.$notification.error(
          `Não é possivel salvar sem nenhuma iniciativa`
        );
        return;
      }

      this.payload.territorioIniciativa = this.payload.territorioIniciativa.map(
        (item) => ({
          ...item,
          selection: false,
        })
      );

      this.$emit("onSave", this.payload.territorioIniciativa);
      this.limpar();
      this.dialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
.dates {
  column-gap: 20px;
}
</style>
